import { Fragment } from "react";
import ContentLoader from "react-content-loader";

export const RenderSearchLoading = () => {
  
  return (
    <Fragment>
      {Array.from({ length: 10 }, (_, index) => (
        <ContentLoader
          key={index}
          backgroundColor={'#a7adba'}
          foregroundColor={'#c0c5ce'}
          viewBox='0 0 500 35'
        >
          <rect x='0' y='10' rx='2' ry='2' width='300' height='13' />
          <rect x='0' y='25' rx='2' ry='2' width='250' height='10' />
        </ContentLoader>
      ))}
    </Fragment>
  );
};